import React from "react";

const Badge = ({ variant = "primary", children, className = "", ...props }) => {
    const classes = ["ui-badge", `ui-badge--${variant}`, className]
        .filter(Boolean)
        .join(" ");

    return (
        <span className={classes} {...props}>
            {children}
        </span>
    );
};

export default Badge;

